const STORAGE_KEY = 'admin-theme';
const browser = typeof window !== 'undefined';

function getInitialTheme(): 'light' | 'dark' {
  if (!browser) return 'light';

  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'dark' || stored === 'light') {
    return stored;
  }

  return window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light';
}

class Theme {
  current = $state<'light' | 'dark'>(getInitialTheme());

  constructor() {
    if (browser) {
      this.applyTheme(this.current);
    }
  }

  toggle() {
    this.current = this.current === 'light' ? 'dark' : 'light';
    this.applyTheme(this.current);
  }

  private applyTheme(theme: 'light' | 'dark') {
    if (!browser) return;

    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem(STORAGE_KEY, theme);
  }
}

export const theme = new Theme();
